import {
  EHeadingStyleVariant,
  ELinkVariant,
  ETextStyleVariant,
  Heading,
  Link,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import MaxWidth from '@/components/common/layout/MaxWidth';
import { useBreakpoint } from '@/hooks/useBreakpoint';

import { DesktopTimeline } from './DesktopTimeline';
import { MobileTimeline } from './MobileTimeline';

const Timeline = () => {
  const { isAboveTablet } = useBreakpoint();

  return (
    <section className="py-20 text-white bg-gray-800 md:py-24 xl:py-48">
      <MaxWidth className="justify-center px-6 mx-auto">
        <Heading
          className="pb-6 md:text-center"
          variant={isAboveTablet ? EHeadingStyleVariant.H3Alt : EHeadingStyleVariant.H2Alt}>
          <FormattedMessage defaultMessage="Made outdoorsy" id="ai+UNc" />
        </Heading>
        <div className="flex justify-center">
          <Text
            className="text-center pb-14 lg:pb-24 max-w-[936px]"
            variant={
              isAboveTablet ? ETextStyleVariant.LargeRegular : ETextStyleVariant.MediumRegular
            }>
            <FormattedMessage
              defaultMessage="Born from a personal appreciation for the mountains, lakes, and oceans, the Outdoorsy Group was founded in 2015 by entrepreneurs <jeff>Jeff</jeff> and <jen>Jen</jen> with a mission to share the freedom and adventure of the outdoors with the world. They launched <outdoorsy>Outdoorsy.com</outdoorsy> in 2015, which quickly became a leading outdoor travel marketplace. As we grew, we identified a critical gap: traditional insurance was not built for the sharing economy. This led us to create Roamly, our innovative AI-powered insurance platform offering a full suite of recreational specialty products and leading to our recent appointment as a Lloyd's Coverholder. This milestone gives us global credibility and a significant advantage in the market. Today, our ecosystem also includes the Outdoorsy Destination Network, which offers premium camping and glamping retreats."
              id="jE50jT"
              values={{
                jeff: chunks => (
                  <Link
                    variant={ELinkVariant.Underline}
                    onDark={true}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.linkedin.com/in/jeffcavins/">
                    {chunks}
                  </Link>
                ),
                jen: chunks => (
                  <Link
                    variant={ELinkVariant.Underline}
                    onDark={true}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.linkedin.com/in/jenniferleeyoung/">
                    {chunks}
                  </Link>
                ),
                outdoorsy: chunks => (
                  <Link
                    variant={ELinkVariant.Underline}
                    onDark={true}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.outdoorsy.com/">
                    {chunks}
                  </Link>
                ),
              }}
            />
          </Text>
        </div>
      </MaxWidth>
      {isAboveTablet ? <DesktopTimeline /> : <MobileTimeline />}
    </section>
  );
};

export default Timeline;
